var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-content",class:[
    {'white-border pt-10': _vm.dark},
    {'heading-text font-weight-bold primary--text text--lighten-2': !_vm.$theme.isDefault}
  ]},[(_vm.$theme.isDefault)?_c('h2',{staticClass:"w-content heading-text font-weight-bold pb-2",class:!_vm.dark ? 'primary--text text--lighten-2' : 'white--text'},[_vm._t("default")],2):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }